// extracted by mini-css-extract-plugin
export default {"currentIcon":"BearerMapProvider_currentIcon__eEkqQ","mapContainerClassName":"BearerMapProvider_mapContainerClassName__JE5WL"};